import React, { useState, useRef, useEffect } from "react";
import Footer from "./Footer";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

function AdvisoryManagement(props) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [selectedValue, setSelectedValue] = useState("option1");


    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const [isOpen1, setIsOpen1] = useState(false);
    const dropdownRef1 = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside1 = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside1);
        return () => document.removeEventListener("mousedown", handleClickOutside1);
    }, []);

    return (
        <>
            <div className="container-fluid mt-60px mb-5 pb-5">
                <div className="row pt-3">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="threshold-box p-3 ">
                            <h5>Advisory Management</h5>
                        </div>

                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="searchBox mt-3">
                                <div className="d-flex justify-content-end">
                                    <div className="form-group">
                                        <input type="text" name="" placeholder="Search" className="form-control h40px" />
                                        <img src="./assets/images/search.png" alt="" />
                                    </div>

                                    <button className="btn btn-cancel mt-3 ms-2" onClick={handleShow}>+ Schedule New Alert </button>
                                </div>
                            </div>

                            <div className="table-responsive mb-5">
                                <table className="table tbl_new">
                                    <thead>
                                        <tr>
                                            <th>S.no</th>
                                            <th>Weeks</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                            <th>Sent on</th>
                                            <th>Options </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>09/09/2025 - 15/09/2025</td>
                                            <td>
                                                <div className="d-flex">
                                                    <div>
                                                        <div className="mb-1">09/09/2025</div>
                                                        <div className="mb-1">High <img src="./assets/images/error.png" alt="" /></div>
                                                        <div className="form-check mb-1">
                                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
                                                            <label className="form-check-label1" for="flexCheckChecked">
                                                                Advisory
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="ms-5">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
                                                            <label className="form-check-label" for="flexCheckChecked">
                                                                10/09/2025
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td><span className="sentText">Sent</span></td>
                                            <td>Sunday</td>
                                            <td style={{ position: "relative" }}>
                                                <div ref={dropdownRef} className="dropdown">
                                                    {/* Toggle Button */}
                                                    <button
                                                        className="btn"
                                                        type="button"
                                                        onClick={() => setIsOpen(!isOpen)}
                                                        style={{
                                                            background: "transparent",
                                                            border: "none",
                                                            padding: 0,
                                                        }}
                                                    >
                                                        <img
                                                            src="./assets/images/arrow_up.png"
                                                            alt="options"
                                                            style={{ width: "20px", cursor: "pointer" }}
                                                        />
                                                    </button>

                                                    {/* Dropdown Menu */}
                                                    {isOpen && (
                                                        <ul
                                                            className="dropdown-menu show"
                                                            style={{
                                                                display: "block",
                                                                position: "absolute",
                                                                top: "100%",
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                minWidth: "140px",
                                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                                                zIndex: 1000,
                                                            }}
                                                        >
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => alert("Edit clicked")}
                                                                >
                                                                    ✏️ Edit
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => alert("Delete clicked")}
                                                                >
                                                                    🗑️ Delete
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => alert("View clicked")}
                                                                >
                                                                    👁️ View
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </div>
                                            </td>

                                        </tr>

                                        <tr>
                                            <td>2</td>
                                            <td>09/09/2025 - 15/09/2025</td>
                                            <td>
                                                <div className="d-flex">
                                                    <div>
                                                        <div className="mb-1">09/09/2025</div>
                                                        <div className="mb-1">High <img src="./assets/images/error.png" alt="" /></div>
                                                        <div className="form-check mb-1">
                                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
                                                            <label className="form-check-label1" for="flexCheckChecked">
                                                                Advisory
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="ms-5">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
                                                            <label className="form-check-label" for="flexCheckChecked">
                                                                10/09/2025
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td><span className="sentText">Sent</span></td>
                                            <td>Sunday</td>
                                            <td style={{ position: "relative" }}>
                                                <div ref={dropdownRef1} className="dropdown">
                                                    {/* Toggle Button */}
                                                    <button
                                                        className="btn"
                                                        type="button"
                                                        onClick={() => setIsOpen(!isOpen1)}
                                                        style={{
                                                            background: "transparent",
                                                            border: "none",
                                                            padding: 0,
                                                        }}
                                                    >
                                                        <img
                                                            src="./assets/images/arrow_up.png"
                                                            alt="options"
                                                            style={{ width: "20px", cursor: "pointer" }}
                                                        />
                                                    </button>

                                                    {/* Dropdown Menu */}
                                                    {isOpen1 && (
                                                        <ul
                                                            className="dropdown-menu show"
                                                            style={{
                                                                display: "block",
                                                                position: "absolute",
                                                                top: "100%",
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                minWidth: "140px",
                                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                                                zIndex: 1000,
                                                            }}
                                                        >
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => alert("Edit clicked")}
                                                                >
                                                                    ✏️ Edit
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => alert("Delete clicked")}
                                                                >
                                                                    🗑️ Delete
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => alert("View clicked")}
                                                                >
                                                                    👁️ View
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </div>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-responsive mt-4">
                                <table className="table tbl_new tdColor table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Camp</th>
                                            <td>Camp 2</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <th>Species</th>
                                            <td>Oreochromis macrochir</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>

                                        <tr>
                                            <th>Dates</th>
                                            <td>09/10/2025</td>
                                            <td>10/10/2025</td>
                                            <td>11/10/2025</td>
                                            <td>12/10/2025</td>
                                            <td>13/10/2025</td>
                                            <td>14/10/2025</td>
                                            <td>15/10/2025</td>
                                        </tr>

                                        <tr>
                                            <th>Max Air Temp</th>
                                            <td>40</td>
                                            <td>40</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                        </tr>

                                        <tr>
                                            <th>Min Air Temp</th>
                                            <td>40</td>
                                            <td>40</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                        </tr>

                                        <tr>
                                            <th>Pond Temp</th>
                                            <td>40</td>
                                            <td>40</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                        </tr>

                                        <tr>
                                            <th>Max Pond Temp</th>
                                            <td>40</td>
                                            <td>40</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                        </tr>

                                        <tr>
                                            <th>Min Pond Temp</th>
                                            <td>40</td>
                                            <td>40</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                            <td>20</td>
                                        </tr>

                                        <tr>
                                            <th>Risk Level</th>
                                            <td><div className="mb-1">High <img alt="" src="./assets/images/error.png" /></div></td>
                                            <td><div className="mb-1">High <img alt="" src="./assets/images/error.png" /></div></td>
                                            <td>Normal</td>
                                            <td>Normal</td>
                                            <td>Normal</td>
                                            <td>Normal</td>
                                            <td>Normal</td>
                                        </tr>

                                        <tr>
                                            <th>Advisory</th>
                                            <td><a href="#">Click to View</a></td>
                                            <td><a href="#">Click to View</a></td>
                                            <td><a href="#">Click to View</a></td>
                                            <td><a href="#">Click to View</a></td>
                                            <td><a href="#">Click to View</a></td>
                                            <td><a href="#">Click to View</a></td>
                                            <td><a href="#">Click to View</a></td>
                                        </tr>

                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={show} onHide={handleClose}  {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="modalBoxNew text-center">
                                <p><img src="./assets/images/Clock.png" alt="" /></p>
                                <h3>Scheduled Sent</h3>
                                <p>Scheduled to send on 13/10/2025</p>
                            </div>

                            <div className="lightBoxNew">
                                <h4>Advisory</h4>
                                <div key="inline-radio" className="mb-3">
                                    <Form.Check
                                        inline
                                        label="English"
                                        name="group1"
                                        type="radio"
                                        id="inline-radio-1"
                                        value="option1"
                                        checked={selectedValue === "option1"}
                                        onChange={(e) => setSelectedValue(e.target.value)}
                                    />
                                    <Form.Check
                                        inline
                                        label="Bemba"
                                        name="group1"
                                        type="radio"
                                        id="inline-radio-2"
                                        value="option2"
                                        checked={selectedValue === "option2"}
                                        onChange={(e) => setSelectedValue(e.target.value)}
                                    />
                                </div>

                                <div className="scrollBox" style={{height:'230px', overflowY:'scroll'}}>
                                   
                                    <p className="mb-0"> --------------EMERGENCY!!!---------------------t</p>
                                   <p className="mb-0"> Water temperature is reaching 12°C!!!</p>
                                   <p className="mb-0"> Water temperature is predicted to increase to high-risk levels over the next 8 to 12 hours.</p>
                                   <p className="mb-0"> Water temperature that is too high or too low affects fish health. Water temperature affects key parameters that can
                                     also affect fish health, such as dissolved Oxygen, pH, ammonia, nitrite.</p>
                                   <p className="mb-0"> --------------MONITORING:--------------------</p>
                                   <p className="mb-0"> Monitor the following parameters:</p>
                                  <p className="mb-0">  Water temperature, air temperature, Dissolved Oxygen (DO), pH, ammonia, nitrite, and fish behaviors.</p>
                                   <p className="mb-0"> FREQUENCY:</p>
                                   <p className="mb-0"> Every 4 hours during the day and night - 06h00, 10h00, 14h00, 18h00, 22h00, 02h00)</p>

                                   <p className="mb-0"> --------------MITIGATION:--------------------</p>
                                   <p className="mb-0"> FLUSHING: If any measurements exceed the below values, PLEASE add freshwater from the
                                     water source, continue to monitor at the outlet; once a parameter has decreased below 
                                     the level below, stop adding water.</p>

                                    <p className="mb-0">FEEDING/FERTILIZING: If any measurements exceed the below values, PLEASE reduce the number
                                     of feeds by 1 and also feed slowly until fish stop feeding.</p>

                                    <p className="mb-0">BEHAVIOR: If fish display any stress-related behavior such as gasping for air at the 
                                    surface, swimming or lying on the side, or floating still at the surface but still moving,
                                     PLEASE prepare to harvest fish or move them to another pond with temperature, DO, pH, 
                                     ammonia, and nitrite in safe limits.</p>
                                 

                                    <p className="mb-0">Temperature &lt; 14°C</p>
                                    <p className="mb-0">DO  &lt; 6 mg/l</p>
                                    <p className="mb-0">pH increasing to 9 or more</p>
                                    <p className="mb-0">pH decreasing to 7 or less</p>
                                   <p className="mb-0"> Ammonia XXX</p>
                                   <p className="mb-0"> Nitrite XXX</p>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center align-items-center mt-3">
                                <button className="btn btnsend me-4">Edit Advisory</button>
                                 <button className="btn btnsend">Send</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer> */}
            </Modal>

            <Footer />
        </>
    )
}

export default AdvisoryManagement